import { TranslatableEntity } from '@/interfaces/translatableEntity';

export class DonationType implements TranslatableEntity {
  private _id: number;
  private _createdAt: string;
  private _name: string;
  private _description: string;
  private _icon: string;
  private _color: string;
  private _descriptionTranslationKey: string;
  private _nameTranslationKey: string;
  private _type: Type;

  constructor(
    id: number,
    createdAt: string,
    name: string,
    description: string,
    icon: string,
    color: string,
    type: Type,
    descriptionTranslationKey: string,
    nameTranslationKey: string
  ) {
    this._id = id;
    this._createdAt = createdAt;
    this._name = name;
    this._description = description;
    this._icon = icon;
    this._color = color;
    this._type = type;
    this._descriptionTranslationKey = descriptionTranslationKey;
    this._nameTranslationKey = nameTranslationKey;
  }

  get id(): number {
    return this._id;
  }

  get createdAt(): string {
    return this._createdAt;
  }

  get name(): string {
    return this._name;
  }

  get description(): string {
    return this._description;
  }

  get icon(): string {
    return this._icon;
  }

  get color(): string {
    return this._color;
  }

  get descriptionTranslationKey(): string {
    return this._descriptionTranslationKey;
  }

  get nameTranslationKey(): string {
    return this._nameTranslationKey;
  }

  get type(): Type {
    return this._type;
  }
}

export enum Type {
  MEMORY_GIFT = 'MEMORY_GIFT',
  CONTRIBUTION = 'CONTRIBUTION',
}

export function isMemoryGift(type: Type): boolean {
  return type === Type.MEMORY_GIFT;
}

export function isContribution(type: Type): boolean {
  return type === Type.CONTRIBUTION;
}
